
import { useEffect, useRef } from "react";


const LiveCommentContent = ({userName,message,emoji}) => {
    const scrollToMessage = useRef();

    useEffect(() => {
        scrollToMessage.current?.scrollIntoView({behavior:"smooth"});
       
       },[message]);

    return (
    <div className="livecommentcontent" ref={scrollToMessage}>
        <p id="countreactiontext" style={{fontWeight:"bold"}}>{userName}</p>

        <pre id="countreactiontext" style={{width:"auto",whiteSpace:"pre-wrap",fontSize:"0.8em"}}>{message}</pre>

        {emoji && emoji !== "" && 
        <img id="countreactiontext" src={emoji} alt="emoji" style={{width:"3.2em", height:"3.2em",objectFit:"contain",caretColor:"transparent"}}/>
        }
        
    </div>  
    );
}
export default LiveCommentContent;